export class CreateVaultRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vaultAccountId",
            "baseName": "vaultAccountId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "vaultAttributes",
            "baseName": "vaultAttributes",
            "type": "VaultProviderAttributesInput",
            "format": ""
        },
        {
            "name": "resourceTags",
            "baseName": "resourceTags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "bucketName",
            "baseName": "bucketName",
            "type": "string",
            "format": ""
        },
        {
            "name": "enableCspAssistedImmutability",
            "baseName": "enableCspAssistedImmutability",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateVaultRequest.attributeTypeMap;
    }
    constructor() {
    }
}
